// Namen en uitleg van de modules in het Turks, Arabisch, Duits en Frans (golf 3-integratie). Het
// register (registry.ts) houdt nl en en bij de module zelf; deze talen staan hier apart, zodat een
// vertaler één bestand heeft. Ontbreekt iets, dan valt moduleText() terug op het Nederlands.
// Alleen de webapp leest dit (Instellingen · Modules); de kiosk importeert het register niet.
export const MODULE_TEXTS = {
    rides: {
        label: {
            tr: 'Götürme ve getirme',
            ar: 'التوصيل والإحضار',
            de: 'Bringen und Abholen',
            fr: 'Déposer et récupérer',
        },
        description: {
            tr: 'Her gün kim götürüyor, kim getiriyor; "Olmuyor mu? Başkası" ve Ulaşım sayfasıyla.',
            ar: 'من يوصل ومن يُحضر، لكل يوم، مع «لا أستطيع؟ شخص آخر» وصفحة التوصيلات.',
            de: 'Wer bringt und wer holt ab, pro Tag, mit „Geht nicht? Jemand anders“ und der Seite Fahrten.',
            fr: 'Qui dépose et qui récupère, chaque jour, avec « Pas possible ? Quelqu’un d’autre » et la page Trajets.',
        },
        options: {
            show_in_agenda: {
                label: {
                    tr: 'Götürme ve getirmeyi takvimde göster',
                    ar: 'إظهار التوصيل والإحضار في الأجندة',
                    de: 'Bringen und Abholen im Kalender zeigen',
                    fr: 'Afficher dépose et récupération dans l’agenda',
                },
                description: {
                    tr: 'Her etkinlikte: "{a} götürüyor · {b} getiriyor". Kapalı: yalnızca etkinlik sayfasında ve Ulaşım’da.',
                    ar: 'في كل موعد: «{a} يوصل · {b} يُحضر». عند الإطفاء: فقط في صفحة الموعد وفي التوصيلات.',
                    de: 'Bei jedem Termin: „{a} bringt · {b} holt ab“. Aus: nur im Terminblatt und bei Fahrten.',
                    fr: 'Sur chaque événement : « {a} dépose · {b} récupère ». Désactivé : seulement sur la fiche de l’événement et dans Trajets.',
                },
            },
            travel_blocks: {
                label: {
                    tr: 'Yolculuk süresi ayrı bir blok olarak',
                    ar: 'مدة الطريق ككتلة مستقلة',
                    de: 'Fahrzeit als eigener Block',
                    fr: 'Temps de trajet en bloc à part',
                },
                description: {
                    tr: 'Gün ve hafta görünümünde etkinlikten önce ince bir blok: kim sürüyor ve ne kadar sürüyor.',
                    ar: 'في عرض اليوم والأسبوع كتلة رفيعة قبل الموعد: من يقود وكم يستغرق.',
                    de: 'In Tages- und Wochenansicht ein schmaler Block vor dem Termin: wer fährt und wie lange.',
                    fr: 'Dans le jour et la semaine, un bloc fin avant l’événement : qui conduit et combien de temps.',
                },
            },
        },
    },
    reminders: {
        label: { tr: 'Hatırlatmalar', ar: 'التذكيرات', de: 'Erinnerungen', fr: 'Rappels' },
        description: {
            tr: 'Bir etkinlikten önce tablette bir uyarı, örneğin "Antrenmana hazırlan", ve bir hazırlık listesi.',
            ar: 'تنبيه على الجهاز اللوحي قبل الموعد، مثل «استعد للتدريب»، مع قائمة لتجهيز الحقيبة.',
            de: 'Ein Hinweis auf dem Tablet vor einem Termin, etwa „Fertig machen fürs Training“, mit einer Packliste.',
            fr: 'Un signal sur la tablette avant un événement, comme « Se préparer pour l’entraînement », avec une liste à emporter.',
        },
    },
    travel_time: {
        label: {
            tr: 'Yolculuk süresi ve yola çıkma',
            ar: 'مدة الطريق والانطلاق',
            de: 'Fahrzeit und Losgehen',
            fr: 'Temps de trajet et départ',
        },
        description: {
            tr: 'Ne kadar yolda olacağın ve yola çıkma zamanı gelince tablette bir uyarı.',
            ar: 'كم ستكونون في الطريق، وتنبيه على الجهاز اللوحي عندما يحين وقت الانطلاق.',
            de: 'Wie lange ihr unterwegs seid, und ein Hinweis auf dem Tablet, wenn es Zeit ist loszugehen.',
            fr: 'Combien de temps dure le trajet, et un signal sur la tablette quand il est temps de partir.',
        },
    },
    location_weather: {
        label: { tr: 'Konum ve hava', ar: 'الموقع والطقس', de: 'Ort und Wetter', fr: 'Lieu et météo' },
        description: {
            tr: 'Hava durumu ve mont-çizme önerileri için ailenin kaba konumu (asla bir adres değil).',
            ar: 'مكان تقريبي للعائلة (وليس عنوانًا أبدًا) للطقس ونصائح المعاطف والأحذية.',
            de: 'Ein grober Ort der Familie (nie eine Adresse) für das Wetter und die Jacken-und-Stiefel-Tipps.',
            fr: 'Un lieu approximatif pour la famille (jamais une adresse) pour la météo et les conseils manteau et bottes.',
        },
    },
    place_search: {
        label: { tr: 'Yer arama', ar: 'البحث عن الأماكن', de: 'Orte suchen', fr: 'Recherche de lieux' },
        description: {
            tr: '"Nerede" alanında yazarken bir havuz, okul veya mağaza seç (Google Haritalar ile). Uygulama böylece yolculuk süresini de hesaplar.',
            ar: 'اختر مسبحًا أو مدرسة أو متجرًا في خانة «أين» أثناء الكتابة (عبر خرائط Google). وبذلك يحسب التطبيق مدة الطريق أيضًا.',
            de: 'Bei „Wo“ beim Tippen ein Schwimmbad, eine Schule oder ein Geschäft wählen (über Google Maps). Damit berechnet die App auch die Fahrzeit.',
            fr: 'Choisir une piscine, une école ou un magasin dans « Où » en tapant (via Google Maps). L’appli calcule alors aussi le temps de trajet.',
        },
    },
    prayer: {
        label: {
            tr: 'Namaz vakitleri',
            ar: 'مواقيت الصلاة',
            de: 'Gebetszeiten',
            fr: 'Heures de prière',
        },
        description: {
            tr: 'Yalnızca "Ailemize uyan"da İslam seçiliyse ve ailenin onayından sonra.',
            ar: 'فقط عند اختيار الإسلام في «ما يناسب عائلتنا»، وبعد موافقة العائلة.',
            de: 'Nur mit Islam in „Was zu unserer Familie passt“ und erst nach dem Ja der Familie.',
            fr: 'Seulement avec l’islam dans « Ce qui convient à notre famille », et après l’accord de la famille.',
        },
        options: {
            // Golf 4 (DESIGN §8.GB.14).
            ramadan: {
                label: {
                    tr: 'Panoda Ramazan',
                    ar: 'رمضان على اللوحة',
                    de: 'Ramadan auf der Tafel',
                    fr: 'Le Ramadan sur le tableau',
                },
                description: {
                    tr: 'Ramazan boyunca orucun başlangıcı ve bitişi panoda büyük, son saatte sakin bir geri sayımla. Kendi sesi yok.',
                    ar: 'خلال رمضان يظهر بدء الصيام ونهايته بشكل كبير على اللوحة، مع عدّ تنازلي هادئ في الساعة الأخيرة. بلا صوت خاص.',
                    de: 'Im Ramadan Beginn und Ende des Fastens groß auf der Tafel, mit einem ruhigen Countdown in der letzten Stunde. Kein eigener Ton.',
                    fr: 'Pendant le Ramadan, le début et la fin du jeûne en grand sur le tableau, avec un compte à rebours calme dans la dernière heure. Pas de son propre.',
                },
            },
            // Koran luisteren (1 okt 2026).
            quran_quiet: {
                label: {
                    tr: 'Sessiz saatlerde Kuran dursun',
                    ar: 'إيقاف القرآن في ساعات الهدوء',
                    de: 'Koran in den Ruhezeiten anhalten',
                    fr: 'Arrêter le Coran pendant les heures calmes',
                },
                description: {
                    tr: 'Panoda Kuran çalıyorsa, sessiz saatler veya gece başladığında durur. Kapalıyken biri başlattıysa çalmaya devam eder.',
                    ar: 'إذا كان القرآن يُتلى على اللوحة، يتوقف عند بدء ساعات الهدوء أو الليل. عند الإيقاف يستمر إذا شغّله أحد.',
                    de: 'Läuft auf der Tafel eine Rezitation, hält sie an, wenn die Ruhezeiten oder die Nacht beginnen. Aus: Was jemand gestartet hat, läuft weiter.',
                    fr: 'Si une récitation passe sur le tableau, elle s’arrête au début des heures calmes ou de la nuit. Désactivé : ce que quelqu’un a lancé continue.',
                },
            },
        },
    },
    holidays: {
        label: {
            tr: 'Özel günler',
            ar: 'الأيام الخاصة',
            de: 'Besondere Tage',
            fr: 'Jours particuliers',
        },
        description: {
            tr: 'Hollanda resmî tatilleri, okul tatilleri ve seçtiğin özel günler. Doğum günleri kalır.',
            ar: 'العطل الرسمية الهولندية والعطل المدرسية والأيام الخاصة التي اخترتموها. وتبقى أعياد الميلاد.',
            de: 'Niederländische Feiertage, Schulferien und die besonderen Tage, die ihr gewählt habt. Geburtstage bleiben.',
            fr: 'Jours fériés néerlandais, vacances scolaires et les jours particuliers que vous avez choisis. Les anniversaires restent.',
        },
    },
    food: {
        label: { tr: 'Yemek', ar: 'الطعام', de: 'Essen', fr: 'Repas' },
        description: {
            tr: 'Alışveriş, tarifler, haftalık menü ve kiler.',
            ar: 'التسوق والوصفات وقائمة الأسبوع والمؤونة.',
            de: 'Einkäufe, Rezepte, Wochenmenü und Vorrat.',
            fr: 'Courses, recettes, menu de la semaine et réserves.',
        },
    },
    wishes: {
        label: { tr: 'Dilekler', ar: 'الأمنيات', de: 'Wünsche', fr: 'Souhaits' },
        description: {
            tr: 'Çocukların dilek listeleri, akrabalarla da paylaşılabilir.',
            ar: 'قوائم أمنيات الأطفال، ويمكن مشاركتها مع الأقارب أيضًا.',
            de: 'Wunschlisten der Kinder, auch mit der Familie zu teilen.',
            fr: 'Les listes de souhaits des enfants, à partager aussi avec la famille.',
        },
    },
    messages: {
        label: { tr: 'Mesajlar', ar: 'الرسائل', de: 'Nachrichten', fr: 'Messages' },
        description: {
            tr: 'Pano, ebeveynler ve akrabalar arasında kısa mesajlar ve sesli mesajlar.',
            ar: 'رسائل قصيرة ورسائل صوتية بين اللوحة والوالدين والأقارب.',
            de: 'Kurze Nachrichten und Sprachnachrichten zwischen Board, Eltern und Familie.',
            fr: 'Petits messages et messages vocaux entre le tableau, les parents et la famille.',
        },
    },
    rooms: {
        label: {
            tr: 'Odalar ve odada kalanlar',
            ar: 'الغرف والمقيمون',
            de: 'Zimmer und Bewohner',
            fr: 'Chambres et occupants',
        },
        description: {
            tr: 'Bir yatak odasındaki tablet yalnızca orada uyuyanları gösterir. Kapalı: her tablet bütün aileyi gösterir.',
            ar: 'الجهاز اللوحي في غرفة نوم يعرض فقط من ينام فيها. عند الإطفاء: كل جهاز لوحي يعرض العائلة كلها.',
            de: 'Ein Tablet im Schlafzimmer zeigt nur, wer dort schläft. Aus: Jedes Tablet zeigt die ganze Familie.',
            fr: 'Une tablette dans une chambre ne montre que qui y dort. Désactivé : chaque tablette montre toute la famille.',
        },
    },
    cleaning: {
        label: { tr: 'Temizlik', ar: 'التنظيف', de: 'Putzen', fr: 'Ménage' },
        description: {
            tr: 'Temizlik dolabı: kim neyi temizledi ve sıra yeniden neye geldi.',
            ar: 'خزانة التنظيف: من نظّف ماذا، وما الذي حان دوره من جديد.',
            de: 'Der Putzschrank: wer was geputzt hat und was wieder dran ist.',
            fr: 'Le placard à ménage : qui a nettoyé quoi, et ce qui est de nouveau à faire.',
        },
    },
    virtual_device: {
        label: { tr: 'Sanal iPad', ar: 'iPad افتراضي', de: 'Virtuelles iPad', fr: 'iPad virtuel' },
        description: {
            tr: 'Kendi tableti olmadan, tarayıcıda pano.',
            ar: 'اللوحة في المتصفح، بدون جهاز لوحي خاص.',
            de: 'Das Board im Browser, ohne eigenes Tablet.',
            fr: 'Le tableau dans le navigateur, sans tablette.',
        },
    },
    push: {
        label: { tr: 'Bildirimler', ar: 'الإشعارات', de: 'Mitteilungen', fr: 'Notifications' },
        description: {
            tr: 'Telefonunda küçük hatırlatmalar: hatırlatmalar, ulaşım, mesajlar ve onayını bekleyenler. Herkes ne alacağını kendisi seçer.',
            ar: 'تنبيهات على هاتفك: التذكيرات والتوصيلات والرسائل وما ينتظر موافقتك. كل شخص يختار ما يصله.',
            de: 'Hinweise auf deinem Handy: Erinnerungen, Fahrten, Nachrichten und was auf dein Ja wartet. Jeder wählt selbst, was er bekommt.',
            fr: 'Des notifications sur ton téléphone: rappels, trajets, messages et ce qui attend ton oui. Chacun choisit ce qu’il reçoit.',
        },
    },
    health: {
        label: { tr: 'Sağlık', ar: 'الصحة', de: 'Gesundheit', fr: 'Santé' },
        description: {
            tr: 'Her çocuğun boyu ve kilosu bir büyüme eğrisinde. Yalnızca ebeveynler için, izin verdikten sonra; tablette asla.',
            ar: 'طول كل طفل ووزنه على منحنى نمو. للوالدين فقط، بعد موافقتكم؛ ولا يظهر أبدًا على الجهاز اللوحي.',
            de: 'Größe und Gewicht pro Kind in einer Wachstumskurve. Nur für Eltern, nach eurer Einwilligung; nie auf dem Tablet.',
            fr: 'Taille et poids de chaque enfant sur une courbe de croissance. Réservé aux parents, après votre consentement ; jamais sur la tablette.',
        },
    },
    // Golf 7 (0048). POORT: moedertaalreview (docs/onderzoek/soera-leren.md §4.10).
    memorize: {
        label: {
            tr: 'Sure ezberi',
            ar: 'حفظ السور',
            de: 'Suren lernen',
            fr: 'Apprendre des sourates',
        },
        description: {
            tr: "Yalnızca 'Ailemize uyan'da İslam ve Kuran dersi seçiliyse, ve her çocuk için onayınızdan sonra.",
            ar: 'فقط عند اختيار الإسلام ودروس القرآن في «ما يناسب عائلتنا»، وبعد موافقتكم لكل طفل.',
            de: 'Nur mit Islam und Koranunterricht in „Was zu unserer Familie passt“ und erst nach eurem Ja für jedes Kind.',
            fr: 'Seulement avec l’islam et les cours de Coran dans « Ce qui convient à notre famille », et après votre accord pour chaque enfant.',
        },
    },
    school: {
        label: { tr: 'Okul', ar: 'المدرسة', de: 'Schule', fr: 'École' },
        description: {
            tr: 'Her çocuk için ödevler, sabit ödev saatleri ve çalışma zamanlı sınavlar; müzik veya özel ders gibi dersler için de. Notlar, karne notları, Cito ve AVI seviyeleri, geçiş sınavı ve okul tavsiyesi. Ödev ve sınavlar panoda görünebilir; notları yalnızca ebeveynler görür.',
            ar: 'الواجبات وأوقات الواجبات الثابتة والاختبارات مع أوقات المراجعة لكل طفل، وأيضًا للدروس مثل الموسيقى أو الدروس الخصوصية. الدرجات وعلامات التقارير ومستويات Cito وAVI واختبار الانتقال والتوصية المدرسية. يمكن أن تظهر الواجبات والاختبارات على اللوحة؛ الدرجات للوالدين فقط.',
            de: 'Hausaufgaben, feste Hausaufgabenzeiten und Arbeiten mit Übungszeiten pro Kind, auch für Unterricht wie Musik oder Nachhilfe. Noten, Zeugnisnoten, Cito- und AVI-Niveaus, Übergangstest und Schulempfehlung. Hausaufgaben und Arbeiten können aufs Board; Noten sehen nur Eltern.',
            fr: 'Devoirs, horaires de devoirs fixes et contrôles avec révisions par enfant, aussi pour des cours comme la musique ou le soutien scolaire. Notes, bulletins, niveaux Cito et AVI, test de passage et avis scolaire. Devoirs et contrôles peuvent aller sur le tableau ; seuls les parents voient les notes.',
        },
        options: {
            board_details: {
                label: {
                    tr: 'Panodaki görevlerde ders ve konu',
                    ar: 'المادة والموضوع في مهام اللوحة',
                    de: 'Fach und Thema in den Aufgaben auf dem Board',
                    fr: 'Matière et sujet dans les tâches du tableau',
                },
                description: {
                    tr: 'Varsayılan olarak görev listesinde yalnızca "Ödev" veya "Sınava çalış" yazar; ayrıntılar uygulamada ve Okul widget\'ında. Açık: ders, kurs ve konu da görünür. Bundan sonra eklediğin veya değiştirdiğin için geçerlidir.',
                    ar: 'افتراضيًا تظهر في قائمة المهام كلمة «واجب» أو «مراجعة لاختبار» فقط؛ التفاصيل في التطبيق وفي أداة المدرسة. عند التفعيل: تظهر المادة والدرس والموضوع أيضًا. ينطبق على ما تضيفه أو تغيّره بعد ذلك.',
                    de: 'Standardmäßig steht auf der Aufgabenliste nur „Hausaufgaben“ oder „Für eine Arbeit üben“; die Details stehen in der App und im Widget Schule. An: auch Fach, Unterricht und Thema. Gilt für alles, was du danach hinzufügst oder änderst.',
                    fr: 'Par défaut, la liste des tâches affiche seulement « Devoirs » ou « Réviser pour un contrôle » ; les détails sont dans l’app et dans le widget École. Activé : aussi la matière, le cours et le sujet. S’applique à ce que tu ajoutes ou modifies ensuite.',
                },
            },
        },
    },
    calendar_sync: {
        label: {
            tr: 'Takvim bağla',
            ar: 'ربط التقويم',
            de: 'Kalender verbinden',
            fr: 'Relier un agenda',
        },
        description: {
            tr: 'Etkinliklerin özel bir bağlantıyla Google Takvim’de, Outlook’ta veya iPhone’da da. Tek yönlü: orada değiştirilenler geri gelmez.',
            ar: 'مواعيدكم أيضًا في تقويم Google أو Outlook أو على iPhone، عبر رابط خاص. باتجاه واحد: ما تغيّره هناك لا يعود.',
            de: 'Eure Termine auch in Google Kalender, Outlook oder auf dem iPhone, über einen eigenen Link. Nur in eine Richtung: Was du dort änderst, kommt nicht zurück.',
            fr: 'Vos événements aussi dans Google Agenda, Outlook ou sur l’iPhone, via un lien privé. Dans un seul sens : ce que tu y changes ne revient pas.',
        },
    },
    languages: {
        label: {
            tr: 'Kişi ve tablet başına dil',
            ar: 'اللغات لكل شخص وجهاز',
            de: 'Sprachen pro Person und Tablet',
            fr: 'Langues par personne et par tablette',
        },
        description: {
            tr: 'Herkese kendi dili: bir ebeveyn her aile üyesi için seçer ve bir odadaki tablet aileden farklı bir dil konuşabilir.',
            ar: 'لكل شخص لغته: يختار أحد الوالدين لكل فرد من العائلة، ويمكن لجهاز لوحي في غرفة أن يتحدث لغة غير لغة العائلة.',
            de: 'Jeder seine eigene Sprache: Ein Elternteil wählt pro Familienmitglied, und ein Tablet in einem Zimmer kann eine andere Sprache sprechen als die Familie.',
            fr: 'Chacun sa langue : un parent choisit pour chaque membre de la famille, et une tablette dans une chambre peut parler une autre langue que la famille.',
        },
    },
    widgets: {
        label: {
            tr: 'Kişiye özel ana ekran',
            ar: 'شاشة رئيسية حسب رغبتك',
            de: 'Startseite nach Wunsch',
            fr: 'Écran d’accueil sur mesure',
        },
        description: {
            tr: 'Herkes Bugün ekranında ne olacağını ve sırasını kendisi seçer; örneğin hava durumu, alışveriş listesi ya da mesajlar.',
            ar: 'يختار كل شخص ما يظهر في شاشة اليوم وبأي ترتيب، مثل الطقس أو قائمة المشتريات أو الرسائل.',
            de: 'Jeder wählt selbst, was auf Heute steht und in welcher Reihenfolge, zum Beispiel das Wetter, die Einkaufsliste oder die Nachrichten.',
            fr: 'Chacun choisit ce qui apparaît sur Aujourd’hui et dans quel ordre, par exemple la météo, la liste de courses ou les messages.',
        },
    },
    // Golf 6b (0043_huishoudtypes).
    rewards: {
        label: { tr: 'Ödüller', ar: 'المكافآت', de: 'Belohnungen', fr: 'Récompenses' },
        description: {
            tr: 'Görevler ve temizlik için puan ve yıldızlar, bir hedef ve tabletteki ödül dükkânı.',
            ar: 'نقاط ونجوم للمهام والتنظيف، وهدف، ومتجر المكافآت على الجهاز اللوحي.',
            de: 'Punkte und Sterne für Aufgaben und Putzen, ein Ziel und der Belohnungsladen auf dem Tablet.',
            fr: 'Des points et des étoiles pour les tâches et le ménage, un objectif et la boutique de récompenses sur la tablette.',
        },
    },
    // 0069: Geldzaken (privé per volwassene).
    money: {
        label: { tr: 'Para işleri', ar: 'الشؤون المالية', de: 'Geldsachen', fr: 'Finances' },
        description: {
            tr: 'Kendi banka dökümünüzü okuyun: sabit giderler, paranızın nereye gittiği, nerede tasarruf edebileceğiniz ve bir birikim ve dağılım planlayıcısı. Özel: yalnızca siz görürsünüz, kendi alanınızda. Finansal tavsiye değildir.',
            ar: 'اقرأ كشف حسابك البنكي: المصاريف الثابتة، أين تذهب أموالك، أين يمكنك التوفير، ومخطط للاحتياطي والتوزيع. خاص: أنت وحدك تراه، في مساحتك الخاصة. ليس نصيحة مالية.',
            de: 'Deinen eigenen Kontoauszug einlesen: Fixkosten, wohin dein Geld geht, wo du sparen kannst, und ein Rücklage- und Aufteilungsplaner. Privat: nur du siehst es, in deinem eigenen Bereich. Keine Finanzberatung.',
            fr: 'Lire ton propre relevé bancaire : charges fixes, où va ton argent, où tu peux économiser, et un planificateur de réserve et de répartition. Privé : toi seul le vois, dans ton propre espace. Pas un conseil financier.',
        },
    },
    // 0064: Fotolijst.
    photo_frame: {
        label: { tr: 'Fotoğraf çerçevesi', ar: 'إطار الصور', de: 'Fotorahmen', fr: 'Cadre photo' },
        description: {
            tr: 'Kendi fotoğraflarınız panonun ekran koruyucusu olarak: yalnızca fotoğraflar ya da saat, tarih ve birkaç widget ile bir fotoğraf. Fotoğraflar kendi panonuzda gizli kalır.',
            ar: 'صوركم الخاصة كشاشة توقف للوحة: الصور فقط، أو صورة مع الساعة والتاريخ وبعض الأدوات. تبقى الصور خاصة على لوحتكم.',
            de: 'Eure eigenen Fotos als Bildschirmschoner der Tafel: nur die Fotos oder ein Foto mit Uhr, Datum und ein paar Widgets. Die Fotos bleiben privat auf eurer eigenen Tafel.',
            fr: 'Vos propres photos comme économiseur d’écran du tableau : seulement les photos, ou une photo avec l’heure, la date et quelques widgets. Les photos restent privées sur votre propre tableau.',
        },
    },
    // 0068: Gezond op gewicht.
    kompas: {
        label: { tr: 'Sağlıklı kilo', ar: 'وزن صحي', de: 'Gesundes Gewicht', fr: 'Poids en forme' },
        description: {
            tr: 'Ne yediğini, içtiğini ve ne kadar hareket ettiğini sakince takip et; güvenli bir günlük hedef ve anlaşılır grafiklerle. Kişisel: her yetişkin kendisi için tutar ve başka kimse görmez.',
            ar: 'تابع بهدوء ما تأكله وتشربه وكم تتحرك، مع هدف يومي آمن ورسوم بيانية واضحة. شخصي: كل بالغ يتابع لنفسه ولا يراه أحد غيره.',
            de: 'Ruhig festhalten, was du isst, trinkst und wie du dich bewegst, mit einem sicheren Tagesziel und klaren Diagrammen. Persönlich: Jeder Erwachsene führt es für sich, und niemand sonst sieht es.',
            fr: 'Noter calmement ce que tu manges, bois et bouges, avec un objectif quotidien sûr et des graphiques clairs. Personnel : chaque adulte le tient pour lui-même et personne d’autre ne le voit.',
        },
    },
    todos: {
        label: { tr: 'Yapılacaklar', ar: 'المهام اللاحقة', de: 'To-dos', fr: 'Choses à faire' },
        description: {
            tr: 'Tarihi veya saati olmayan işler, örneğin "ayakkabı dolabını boyamak". Bitene kadar panoda görevlerin altında ve bir widget olarak kalırlar.',
            ar: 'أعمال بلا تاريخ أو وقت، مثل «طلاء خزانة الأحذية». تبقى حتى تُنجز، على اللوحة تحت المهام وكأداة.',
            de: 'Aufgaben ohne Datum oder Uhrzeit, etwa „Schuhschrank streichen“. Sie bleiben, bis sie erledigt sind, auf der Tafel unter den Aufgaben und als Widget.',
            fr: 'Des choses sans date ni heure, comme « peindre le meuble à chaussures ». Elles restent jusqu’à ce qu’elles soient faites, sur le tableau sous les tâches et en widget.',
        },
    },
    // 0062: module Jodendom.
    shabbat: {
        label: {
            tr: 'Şabat ve Yahudi takvimi',
            ar: 'السبت والتقويم العبري',
            de: 'Schabbat und jüdischer Kalender',
            fr: 'Chabbat et calendrier juif',
        },
        description: {
            tr: 'Yalnızca "Ailemize uyan"da Yahudilik seçiliyse ve ailenin onayından sonra.',
            ar: 'فقط عند اختيار اليهودية في «ما يناسب عائلتنا»، وبعد موافقة العائلة.',
            de: 'Nur mit Judentum in „Was zu unserer Familie passt“ und erst nach dem Ja der Familie.',
            fr: 'Seulement avec le judaïsme dans « Ce qui convient à notre famille », et après l’accord de la famille.',
        },
    },
    // 0063: module Hindoeïsme.
    almanac: {
        label: { tr: 'Hinduizm', ar: 'الهندوسية', de: 'Hinduismus', fr: 'Hindouisme' },
        description: {
            tr: 'Panoda panchang, bayramlar ve oruç günleri. Yalnızca "Ailemize uyan"da Hinduizm seçiliyse ve ailenin onayından sonra.',
            ar: 'البانشانغ والأعياد وأيام الصيام على اللوحة. فقط عند اختيار الهندوسية في «ما يناسب عائلتنا»، وبعد موافقة العائلة.',
            de: 'Panchang, Feste und Fastentage auf der Tafel. Nur mit Hinduismus in „Was zu unserer Familie passt“ und erst nach dem Ja der Familie.',
            fr: 'Panchang, fêtes et jours de jeûne sur le tableau. Seulement avec l’hindouisme dans « Ce qui convient à notre famille », et après l’accord de la famille.',
        },
    },
    notes: {
        label: { tr: 'Notlar', ar: 'الملاحظات', de: 'Notizen', fr: 'Notes' },
        description: {
            tr: 'Panoda notlar: parmağınla yaz, klavyeyle yaz ya da söyle. Herkes için ya da tek kişi için, bir renkle; önemliyse sabitlenmiş.',
            ar: 'ملاحظات على اللوحة: اكتب بإصبعك أو بلوحة المفاتيح أو قل شيئًا. للجميع أو لشخص واحد، بلون، ومثبّتة إن كانت مهمة.',
            de: 'Zettel auf der Tafel: mit dem Finger schreiben, tippen oder etwas einsprechen. Für alle oder für eine Person, mit einer Farbe und angeheftet, wenn es wichtig ist.',
            fr: 'Des notes sur le tableau : écris avec ton doigt, tape ou dis quelque chose. Pour tout le monde ou pour une personne, avec une couleur, et épinglée si c’est important.',
        },
        options: {
            cloud_speech: {
                label: {
                    tr: 'Google ile konuşmadan yazıya (ses Google’a gider)',
                    ar: 'تحويل الكلام إلى نص عبر Google (يُرسل الصوت إلى Google)',
                    de: 'Sprache zu Text über Google (Audio geht an Google)',
                    fr: 'Voix en texte via Google (l’audio part chez Google)',
                },
                description: {
                    tr: 'Cihaz konuşmayı kendisi yazıya çeviremiyorsa tarayıcı sesini metne çevirmek için Google’a gönderir. Bu seçenek olmadan nota metinsiz bir kayıt ekleriz.',
                    ar: 'إذا لم يستطع الجهاز تحويل الكلام إلى نص بنفسه، يرسل المتصفح صوتك إلى Google ليحوّله إلى نص. بدون هذا الخيار نحفظ تسجيلًا مع الملاحظة بلا نص.',
                    de: 'Kann das Gerät Sprache nicht selbst umwandeln, schickt der Browser deine Stimme an Google, um Text daraus zu machen. Ohne diese Wahl speichern wir eine Aufnahme bei der Notiz, ohne Text.',
                    fr: 'Si l’appareil ne sait pas transformer la voix en texte lui-même, le navigateur envoie ta voix à Google pour en faire du texte. Sans ce choix, nous gardons un enregistrement avec la note, sans texte.',
                },
            },
        },
    },
    chore_rotation: {
        label: {
            tr: 'Nöbet çizelgesi',
            ar: 'جدول المناوبة',
            de: 'Putzplan',
            fr: 'Tableau de roulement',
        },
        description: {
            tr: 'Mutfak, banyo, koridor, çöp ve bulaşık her hafta herkes arasında adilce döner; takas ve yokluk da var. Koridordaki pano sıranın kimde olduğunu gösterir.',
            ar: 'المطبخ والحمام والممر والقمامة والجلي تدور كل أسبوع بعدل بين الجميع، مع التبديل والغياب. تُظهر اللوحة في الممر على من الدور.',
            de: 'Küche, Bad, Flur, Müll und Abwasch wechseln jede Woche fair unter allen, mit Tauschen und Abwesenheit. Das Board im Flur zeigt, wer dran ist.',
            fr: 'Cuisine, salle de bain, couloir, poubelles et vaisselle tournent chaque semaine équitablement entre tous, avec échanges et absences. L’écran du couloir montre à qui c’est le tour.',
        },
    },
    // Golf 8 (0049_samen_wonen): Samen wonen.
    dinner_list: {
        label: { tr: 'Kim yemekte', ar: 'من سيتناول العشاء', de: 'Wer isst mit', fr: 'Qui mange' },
        description: {
            tr: 'Son saatten önce katıl ya da çekil, kim pişiriyor ve kaç kişi yiyoruz.',
            ar: 'سجّل حضورك أو غيابك قبل الموعد النهائي، ومن يطبخ، وكم عدد من سيأكل.',
            de: 'Vor der Frist an- oder abmelden, wer kocht und mit wie vielen wir essen.',
            fr: 'S’inscrire ou se désinscrire avant l’heure limite, qui cuisine et combien nous serons à table.',
        },
        options: {
            on_board: {
                label: {
                    tr: 'Koridordaki panoda',
                    ar: 'على لوحة الممر',
                    de: 'Auf dem Board im Flur',
                    fr: 'Sur l’écran du couloir',
                },
                description: {
                    tr: 'Bu akşamki yemek ve aşçı panoda; isimle katılma ya da çekilme.',
                    ar: 'عشاء الليلة ومن يطبخ على اللوحة، مع التسجيل بالاسم.',
                    de: 'Das Abendessen und wer kocht auf dem Board, mit An- und Abmelden über den Namen.',
                    fr: 'Le dîner de ce soir et le cuisinier sur l’écran, avec inscription par le nom.',
                },
            },
            dinner_costs: {
                label: {
                    tr: 'Alışverişi yiyenler arasında böl',
                    ar: 'تقسيم المشتريات على من أكل',
                    de: 'Einkäufe auf die Essenden aufteilen',
                    fr: 'Partager les courses entre les convives',
                },
                description: {
                    tr: 'Aşçı alışverişi girer; tutar yiyenler arasında bölünür (misafirler getirenin payına sayılır).',
                    ar: 'يُدخل الطاهي المشتريات، فتُقسَّم على من أكل (يُحسب الضيوف على من أحضرهم).',
                    de: 'Wer kocht, trägt den Einkauf ein; er wird auf die Essenden verteilt (Gäste zählen für die Person, die sie mitbrachte).',
                    fr: 'Le cuisinier saisit les courses ; elles sont partagées entre ceux qui ont mangé (les invités comptent pour la personne qui les a amenés).',
                },
            },
        },
    },
    expenses: {
        label: {
            tr: 'Masrafları paylaş',
            ar: 'تقاسم المصاريف',
            de: 'Kosten teilen',
            fr: 'Partager les frais',
        },
        description: {
            tr: 'Kim neyi ödedi ve bakiyeler. Evdeki tüm yetişkinler görür. AMUMIN üzerinden para geçmez.',
            ar: 'من دفع ماذا، والأرصدة. يراها كل البالغين في البيت. لا يمر أي مال عبر AMUMIN.',
            de: 'Wer was bezahlt hat und die Salden. Alle Erwachsenen im Haushalt sehen es. Über AMUMIN läuft kein Geld.',
            fr: 'Qui a payé quoi, et les soldes. Tous les adultes du foyer le voient. Aucun argent ne passe par AMUMIN.',
        },
    },
    bookings: {
        label: { tr: 'Rezervasyon', ar: 'الحجز', de: 'Reservieren', fr: 'Réservations' },
        description: {
            tr: 'Çamaşır makinesi, kurutucu, ortak alan ya da misafir yatağı, ev kurallarıyla.',
            ar: 'الغسالة أو المجفف أو الغرفة المشتركة أو سرير الضيوف، مع قواعد البيت.',
            de: 'Die Waschmaschine, der Trockner, der Gemeinschaftsraum oder das Gästebett, mit Hausregeln.',
            fr: 'Le lave-linge, le sèche-linge, la salle commune ou le lit d’amis, avec les règles de la maison.',
        },
        options: {
            on_board: {
                label: {
                    tr: 'Koridordaki panoda',
                    ar: 'على لوحة الممر',
                    de: 'Auf dem Board im Flur',
                    fr: 'Sur l’écran du couloir',
                },
                description: {
                    tr: 'Her şey için "şimdi boş" ya da kimde olduğu, ve isimle rezervasyon.',
                    ar: 'لكل شيء «متاح الآن» أو مع من هو، والحجز بالاسم.',
                    de: 'Für jedes Ding „jetzt frei“ oder wer es hat, und Reservieren über den Namen.',
                    fr: 'Pour chaque chose « libre maintenant » ou qui l’a, et la réservation par le nom.',
                },
            },
        },
    },
    // Golf 8 (0050, pakket Ouderen): geen alarmdienst; de oudere zegt zelf ja.
    check_in: {
        label: {
            tr: 'Günlük kontrol',
            ar: 'التحقق اليومي',
            de: 'Täglicher Check-in',
            fr: 'Check-in quotidien',
        },
        description: {
            tr: "Panoda tek bir büyük 'Her şey yolunda' düğmesi. Gelmezse aileye haber gider. Acil durum servisi değildir.",
            ar: "زر كبير واحد 'كل شيء بخير' على اللوحة. تتلقى العائلة إشعارًا إذا لم يُضغط. ليست خدمة طوارئ.",
            de: 'Ein großer Knopf „Alles gut“ auf der Tafel. Die Familie bekommt ein Zeichen, wenn er ausbleibt. Kein Notrufdienst.',
            fr: 'Un seul grand bouton « Tout va bien » sur l’écran. La famille est prévenue s’il manque. Pas un service d’urgence.',
        },
    },
    family_circle: {
        label: {
            tr: 'Aile çemberi',
            ar: 'دائرة العائلة',
            de: 'Familienkreis',
            fr: 'Cercle familial',
        },
        description: {
            tr: 'Uzaktaki aile, kişi başına izinlerle takip eder. Yaşlı kişi kendisi evet der.',
            ar: 'تتابع العائلة عن بُعد، بصلاحيات لكل شخص. يوافق كبير السن بنفسه.',
            de: 'Familie aus der Ferne schaut mit, mit Rechten pro Person. Die ältere Person sagt selbst Ja.',
            fr: 'La famille à distance suit, avec des droits par personne. La personne âgée dit oui elle-même.',
        },
    },
};
//# sourceMappingURL=texts.js.map